import React from 'react';

export default function BeautyListSection() {
  const workItems = [
    {
      id: 1,
      
      title: 'Iskustvo',
      description: 'Već 10 godina stvaramo savršene obrve, usne i oči koje govore vašu priču. Naš kozmetički salon specijaliziran je za permanent make up i ponosni smo što povezujemo dvije najljepše hrvatske metropole - Split i Zagreb.',
      
    },
    {
      id: 2,
      
      title: 'Naša priča',
      description: 'Započeli smo 2014. godine s vizijom da svakoj ženi omogućimo da se osjeća prekrasno svaki dan, bez obzira na to koliko vremena ima ujutro za šminkanje. Kroz godine iskustva, usavršili smo tehnike koje današnje žene čine sigurnijima i zadovoljnijima svojom prirodnom ljepotom.',
     
    },
    {
      id: 3,
      
      title: 'Najnovije tehnike',
      description: 'Naš tim stručnjaka koristi najnovije tehnike i proizvode kako bi osigurao da svaki tretman bude siguran, učinkovit i dugotrajan. Bilo da se radi o obrva, usnama ili očima, naš cilj je postići prirodan izgled koji će trajati.',
     
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-pink-100 via-purple-100 to-orange-100">
      <div className="container mx-auto max-w-6xl">
        <h1 className="text-4xl md:text-5xl font-normal text-center text-gray-800 mb-16">
          Vaša ljepota, naša strast
        </h1>
        
        <div className="space-y-16">
          {workItems.map((item, index) => (
            <div key={item.id} className="work-item">
              <div className={`grid md:grid-cols-12 gap-8 items-center ${index % 2 === 1 ? 'md:direction-reverse' : ''}`}>
                {/* Image Column */}
                <div className={`md:col-span-4 ${index % 2 === 1 ? 'md:order-2' : ''}`}>
                  <div className="relative">
                    {/* Placeholder background with emoji */}
                    <div className="bg-gradient-to-br from-pink-200 to-purple-200 rounded-lg h-64 flex items-center justify-center shadow-lg">
                      <div className="text-6xl opacity-50">{item.placeholder}</div>
                    </div>
                    {/* Actual image (when available) */}
                    <img 
                      src={item.image} 
                      alt={item.title}
                      className="absolute inset-0 w-full h-full object-cover rounded-lg opacity-0 hover:opacity-100 transition-opacity duration-300"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                </div>
                
                {/* Content Column */}
                <div className={`md:col-span-8 ${index % 2 === 1 ? 'md:order-1' : ''}`}>
                  <div className="bg-white/90 backdrop-blur-sm rounded-lg p-8 shadow-lg">
                    <h2 className="text-3xl font-normal text-gray-800 mb-6">
                      {item.title}
                    </h2>
                    <p className="text-lg text-gray-700 leading-relaxed font-light">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}